const id_purch_quotationMitra = {

}

export default id_purch_quotationMitra;